export default __webpack_public_path__ + "static/media/Christ.99916b79.png";